import React from 'react'
import { Box, Container, Typography, Paper, Chip, Divider, Avatar } from '@mui/material'
import PersonIcon from '@mui/icons-material/Person'
import StoreIcon from '@mui/icons-material/Store'
import PhoneIcon from '@mui/icons-material/Phone'
import EmailIcon from '@mui/icons-material/Email'
import LocationOnIcon from '@mui/icons-material/LocationOn'
import BadgeIcon from '@mui/icons-material/Badge'

const roleColor = { SERVER: '#3b82f6', MANAGER: '#8b5cf6' }

function ServerProfile() {
  const raw = localStorage.getItem('staff-session')
  const session = raw ? JSON.parse(raw) : {}

  const InfoRow = ({ icon, label, value }) => (
    <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 2, py: 1.5 }}>
      <Box sx={{ color: '#94a3b8', mt: 0.25 }}>{icon}</Box>
      <Box>
        <Typography sx={{ fontSize: '0.72rem', color: '#94a3b8', fontWeight: 600, letterSpacing: '0.04em', mb: 0.25 }}>{label}</Typography>
        <Typography sx={{ fontSize: '0.9rem', color: '#1e293b', fontWeight: 500 }}>{value || '—'}</Typography>
      </Box>
    </Box>
  )

  return (
    <Container maxWidth="sm" sx={{ py: 4 }}>
      <Typography sx={{ fontWeight: 800, fontSize: '1.5rem', color: '#0f172a', mb: 3 }}>My Profile</Typography>

      <Paper elevation={0} sx={{ borderRadius: '20px', border: '1px solid #e2e8f0', overflow: 'hidden', boxShadow: '0 4px 24px rgba(0,0,0,0.06)' }}>
        {/* Header banner */}
        <Box sx={{ background: 'linear-gradient(135deg, #1e293b 0%, #334155 100%)', p: 3, display: 'flex', alignItems: 'center', gap: 2 }}>
          <Avatar sx={{ width: 56, height: 56, bgcolor: roleColor[session.role] || '#3b82f6', fontSize: '1.4rem', fontWeight: 700 }}>
            {session.firstName?.[0]?.toUpperCase() || 'S'}
          </Avatar>
          <Box>
            <Typography sx={{ color: '#f8fafc', fontWeight: 700, fontSize: '1.1rem' }}>
              {session.firstName} {session.lastName}
            </Typography>
            <Chip
              label={session.role}
              size="small"
              sx={{ mt: 0.5, bgcolor: `${roleColor[session.role] || '#3b82f6'}30`, color: '#e2e8f0', fontWeight: 700, fontSize: '0.7rem', border: `1px solid ${roleColor[session.role] || '#3b82f6'}50` }}
            />
          </Box>
        </Box>

        {/* Details */}
        <Box sx={{ p: 3 }}>
          <Typography sx={{ fontSize: '0.75rem', fontWeight: 700, color: '#94a3b8', letterSpacing: '0.05em', mb: 1 }}>PERSONAL INFO</Typography>
          <InfoRow icon={<EmailIcon fontSize="small" />} label="EMAIL" value={session.email} />
          <Divider sx={{ borderColor: '#f1f5f9' }} />
          <InfoRow icon={<BadgeIcon fontSize="small" />} label="ROLE" value={session.role} />
          <Divider sx={{ borderColor: '#f1f5f9' }} />

          <Typography sx={{ fontSize: '0.75rem', fontWeight: 700, color: '#94a3b8', letterSpacing: '0.05em', mt: 2, mb: 1 }}>RESTAURANT</Typography>
          <InfoRow icon={<StoreIcon fontSize="small" />} label="WORKING AT" value={session.restaurantName} />
        </Box>
      </Paper>
    </Container>
  )
}

export default ServerProfile
